export default __webpack_public_path__ + "static/media/australia-light.2202ff86.png";